import { debug as debugLib } from "debug";

export const debug = debugLib("prisma:studio-pcw");
